import {AppConfig} from "../../appConfig";

export class LayerLinksUtils {

    static makeKmlLink(layerCode) {
        const layersParam = encodeURIComponent('vinaros_geoportal:' + layerCode);
        return `${AppConfig.GEONODE_URL}/geoserver/wms/kml?layers=${layersParam}&mode=download`;
    }

    static makeGeojsonLink(layerCode) {
        const layersParam = encodeURIComponent('vinaros_geoportal:' + layerCode);
        return `${AppConfig.APP_URL}/api/layer/${layerCode}/geojson`;
        return `${AppConfig.GEONODE_URL}/geoserver/wfs?srsName=EPSG%3A4326&typename=${layersParam}&outputFormat=json&version=1.0.0&service=WFS&request=GetFeature`;
    }

    static makeCsvLink(layerCode) {
        const layersParam = encodeURIComponent('vinaros_geoportal:' + layerCode);
        return `${AppConfig.GEONODE_URL}/geoserver/wfs?typename=${layersParam}&outputFormat=csv&version=1.0.0&service=WFS&request=GetFeature`;
    }

    static makeGml3Link(layerCode) {
        const layersParam = encodeURIComponent('vinaros_geoportal:' + layerCode);
        return `${AppConfig.GEONODE_URL}/geoserver/wfs?typename=${layersParam}&outputFormat=text%2Fxml%3B+subtype%3Dgml%2F3.1.1&version=1.0.0&service=WFS&request=GetFeature`;
    }

    static makeShapefileLink(layerCode) {
        const layersParam = encodeURIComponent('vinaros_geoportal:' + layerCode);
        return `${AppConfig.APP_URL}/api/layer/${layerCode}/shapefile`;
        return `${AppConfig.GEONODE_URL}/geoserver/wfs?format_options=charset%3AUTF-8&typename=${layersParam}&outputFormat=SHAPE-ZIP&version=1.0.0&service=WFS&request=GetFeature`;
    }

    static makeWmsLink(layerCode) {
        return `${AppConfig.GEONODE_URL}/geoserver/vinaros_geoportal/${layerCode}/wms?request=GetCapabilities`;
    }

    static makeWfsLink(layerCode) {
        return `${AppConfig.GEONODE_URL}/geoserver/vinaros_geoportal/${layerCode}/wfs?request=GetCapabilities`;
    }

    static makeGeonodeLink(layerCode, locale) {
        const url = AppConfig.GEONODE_URL + '/layers/vinaros_geoportal:' + layerCode;
        return `${AppConfig.APP_URL}/${locale}/ruta?url=${btoa(encodeURIComponent(url))}`;
    }
}
